export {Drawer} from 'antd';
export type {DrawerProps, IDrawerState} from 'antd/es/drawer/index';
